<template>
    
    <nav class="breadcrumb">
        
        <span v-for="(parent, index) in parents"
        :key="parent.name">
            <router-link :to="parent" v-if="( index < parents.length - 1) || !titlePrevious">{{ parent.meta.title }}</router-link>
            <router-link :to="parent" v-if="( index === parents.length - 1) && titlePrevious">{{ titlePrevious }}</router-link>
            <span v-if="parents.length > 0"> / </span>
        </span>

        <span>{{ title }}</span>

    </nav>

</template>

<script>

export default {

    data: function() {

        return {
            actual: this.$router.currentRoute,
            title: this.$router.currentRoute.meta.title,
            titlePrevious: null
        }
    },

    computed: {

        parents: function() {
            let routes = []
            let cursor = this.actual

            while ( cursor.meta.parent ) {
                let parent = this.getRoute(cursor.meta.parent)
                routes.unshift(parent)
                cursor = parent
            }
            
            return routes
        }
    },

    methods: {

        getRoute: function( name ) {

            let result = undefined
            this.$router.getRoutes().forEach(route => {           
                if ( route.name === name ) {
                    result = route
                }
            });

            if ( typeof result === 'undefined' ) {
                throw new Error('💥 Route `' + name + '` inconnue');
            }

            return result
        }
    },

    created() {

        this.$router.beforeEach((to, from, next) => {   

            // Mémorise le titre de laquelle on vient
            // Dans le cas où la vue est enfante
            this.titlePrevious = ( to.meta.parent && to.meta.parent === from.name ) ? this.title : null

            this.actual = to
            this.title = this.actual.meta.title

            next()
        })

        this.$root.$on('title', title => {
            this.title = title
        })
    }
}
</script>

<style>

.breadcrumb {
    font-size: 90%;
    margin: 1rem 0;
    text-align: left;
}

.breadcrumb > :not(:last-child) {
    display: none;
}

@media screen and (min-width: 800px) {

    .breadcrumb > :not(:last-child) {
        display: inline;
    }
}

</style>